module.exports = __webpack_public_path__ + "static/img/baby_6.7237a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baby_6.png
// module id = RsuY
// module chunks = 1